<template>
    <ul :class="$style.stepper">
        <slot></slot>
    </ul>
</template>

<script>
    export default {
        name: 'stepper-group-fragment'
    }
</script>

<style module lang="scss">
    @import "../../style/abstract/abstract.functions.scss";
    .stepper {
        padding: 0 rem-calc(40);

        @media (min-width: 31.25em) {
            padding: 0 rem-calc(70) 0 rem-calc(40);
        }
        margin: 0;
        list-style: none;
        display: flex;
    }
</style>